// A tiny signal, not a data channel: "the notification list may have
// changed on the server - re-read it". The bell (components/layout/
// NotificationBell.jsx) owns its own polling and state, so anything that
// causes a server-side notification change (the active-meeting check in
// AppShell, ending a meeting on its details page) just asks it to look
// again instead of waiting up to a full poll interval.

export const NOTIFICATIONS_REFRESH_EVENT = 'copilot:notifications-refresh';

export function requestNotificationsRefresh() {
  try {
    window.dispatchEvent(new Event(NOTIFICATIONS_REFRESH_EVENT));
  } catch (_) {
    // Best-effort only - the bell's own 30s poll catches up regardless.
  }
}
